import PageTitle from "../components/ui/PageTitle";

const TermItem = ({ titles, descriptions, listItems }) => {
  return (
    <div>
      {titles.map((title, index) => (
        <div className="content-item w-full mb-10" key={index}>
          {index === 2 ? (
            <div>
              <h2 className="text-[18px] font-medium text-qblack mb-5">
                {index + 1}. {title}
              </h2>
              <p className="text-[15px] text-qgraytwo leading-7 mb-5">
                {descriptions[index]}
              </p>
              <ul className="list-disc ml-5">
                {listItems.map((item, listItemIndex) => (
                  <li
                    key={listItemIndex}
                    className={
                      listItemIndex === listItems.length - 1
                        ? "text-[15px] text-qgraytwo leading-7 mb-5"
                        : "text-[15px] text-qgraytwo leading-7"
                    }
                  >
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-[15px] text-qgraytwo leading-7 mb-10">
                Certain areas of this Website are restricted from being access
                by you and One2Talk may further restrict access by you
                to any areas of this Website, at any time, in absolute
                discretion. Any user ID and password you may have for this
                Website are confidential and you must maintain confidentiality
                as well.
              </p>
            </div>
          ) : (
            <>
              <h2 className="text-[18px] font-medium text-qblack mb-5">
                {index + 1}. {title}
              </h2>
              <p className="text-[15px] text-qgraytwo leading-7">
                {descriptions[index]}
              </p>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default function Terms() {
  const titles = [
    "What Are Terms and Conditions?",
    "What Are My Intellectual Property Rights?",
    "Do I Have Any Restrictions?",
    "Protect Your Content",
    "Does The Website Offer Any Warranties?",
    "What Are My Limitation of Liability?",
    "What is the concept and importance of indemnification?",
    "What happens if a provision is found to be invalid under applicable law?",
    "Why is it important for users to review these Terms regularly?",
    "What are the implications of One2Talk being allowed to assign, transfer, and subcontract its rights and obligations under these Terms?",
    "What does it mean for these Terms to constitute the entire agreement between One2Talk and the user?",
    "How does the governing law and jurisdiction specified in these Terms impact the resolution of disputes?",
  ];
  const descriptions = [
    "The Website Standard Terms and Conditions written on this webpage shall manage your use of this website. These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions. Minors or people below 18 years old are not allowed to use this Website.",
    "Other than the content you own, under these Terms,One2Talk and/or its licensors own all the intellectual property rights and materials contained in this Website. You are granted limited license only for purposes of viewing the material contained on this Website and using it as described therein.",
    "You are specifically restricted from all of the following:",
    "In these Website Standard Terms and Conditions, 'Your Content'shall mean any audio, video text, images or other material you choose to display on this Website. By displaying Your Content,you grant One2Talk a non-exclusive, worldwide irrevocable, sub licensable license to use, reproduce, adapt,publish, translate and distribute it in any and all media. Your Content must be your own and must not be invading any third-party's rights. One2Talk reserves the right to remove any of Your Content from this Website at any time without notice.",
    "This Website is provided as is, with all faults, and One2Talk express no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.",
    "In no event shall One2Talk, nor any of its officers,directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. One2Talk, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.",
    "You hereby indemnify to the fullest extent One2Talk from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.",
    "If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.",
    "One2Talk is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.",
    "The One2Talk is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.",
    "These Terms constitute the entire agreement between One2Talk and you in relation to your use of this Website, and supersede all prior agreements and understandings.",
    "These Terms will be governed by and interpreted in accordance with the laws of the State of California, and you submit to the non-exclusive jurisdiction of the state and federal courts located in California for the resolution of any disputes.",
  ];
  const listItems = [
    "Publishing any Website material in any other media.",
    "Selling, sublicensing and/or otherwise commercializing any Website material.",
    "Publicly performing and/or showing any Website material.",
    "Using this Website in any way that is or may be damaging to this Website.",
    "Using this Website in any way that impacts user access to this Website",
    "Using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity.",
    "Engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website.",
    "Using this Website to engage in any advertising or marketing.",
  ];
  return (
    <>
      <div className="terms-condition-page w-full pb-[30px]">
        <div className="w-full mb-[30px]">
          <PageTitle
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Terms and condition", path: "/terms-conditions" },
            ]}
            title="Terms and Condition"
          />
        </div>
        <div className="w-full">
          <div className="container-x mx-auto">
            <TermItem
              titles={titles}
              descriptions={descriptions}
              listItems={listItems}
            />
          </div>
        </div>
      </div>
    </>
  );
}
